import { Button } from 'components/Button';
import { Input } from '@/ui/design-system/components/ui/input';
import { IoMdTrash } from 'react-icons/io';
import ModalContainer from 'components/Modal/ModalContainer';
import { Textarea } from '@/ui/design-system/components/ui/textarea';
import { useState } from 'react';

function EditWatchlist({ isOpen, watchlist, onDelete, onUpdate, onCancel }) {
    const [name, setName] = useState(watchlist.name);
    const [description, setDescription] = useState(watchlist.description || '');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (name === watchlist.name && description === watchlist.description)
            return;
        onUpdate({
            id: watchlist.id,
            name,
            description,
        });
    };
    return (
        <ModalContainer isOpen={isOpen} onClose={onCancel}>
            <form onSubmit={handleSubmit}>
                <div css="display: flex; flex-direction: column; text-align: left; gap: 16px;">
                    <h1 css="font-size: 16px;">edit watchlist</h1>
                    <label
                        className="text-sm font-medium text-muted-foreground"
                        htmlFor="watchlist-name"
                    >
                        name
                    </label>
                    <Input
                        id="watchlist-name"
                        maxLength={100}
                        type="text"
                        required={true}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <label
                        className="text-sm font-medium text-muted-foreground mt-2"
                        htmlFor="watchlist-description"
                    >
                        description
                    </label>
                    <Textarea
                        id="watchlist-description"
                        maxLength={1000}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        className="min-h-[200px] resize-y"
                    />
                    <div className="flex justify-end gap-3 my-2">
                        <Button
                            className="mr-auto"
                            intent="secondary"
                            onClick={onDelete}
                        >
                            Delete <IoMdTrash />
                        </Button>
                        <Button intent="secondary" onClick={onCancel}>
                            Cancel
                        </Button>
                        <Button intent="primary" type="submit">
                            Save
                        </Button>
                    </div>
                </div>
            </form>
        </ModalContainer>
    );
}

export default EditWatchlist;
